var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from "react";
import { getItem } from "../../../utils/LocalStorageUtil";
import { TOKEN_KEY } from "../../../utils/StorageKeys";
var WikiContent = function (_a) {
    var content = _a.content, onPageClick = _a.onPageClick, classes = _a.classes;
    var iframeRef = useRef(null);
    var _b = useState(""), processedContent = _b[0], setProcessedContent = _b[1];
    useEffect(function () {
        if (!content)
            return;
        var apiUrl = (process.env.API_URL || "") + "confluence/download";
        var updatedContent = content.replace(/https:\/\/enhanceinc\.atlassian\.net\/wiki\/download/g, apiUrl);
        var replacements = [
            [/@aui-text-color/g, "#172b4d"],
            ['line-height: unit(20 / @aui-font-size-medium);', 'line-height: 1.5;'],
            [/@aui-font-family/g, "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif"],
            [/@aui-font-size-medium/g, "14px"],
            [/@aui-font-weight-normal/g, "400"],
            [/@aui-grid/g, "8px"],
            [/@aui-font-size-small/g, "12px"],
            [/@aui-font-letter-spacing/g, "0px"]
        ];
        var updatedContent1 = updatedContent;
        replacements.forEach(function (_a) {
            var pattern = _a[0], replacement = _a[1];
            updatedContent1 = updatedContent1.replace(pattern, replacement);
        });
        setProcessedContent(function (prev) { return (prev !== updatedContent1 ? updatedContent1 : prev); });
    }, [content]);
    useEffect(function () {
        var iframe = iframeRef.current;
        if (!iframe || !processedContent)
            return;
        var doc = iframe.contentDocument;
        if (!doc)
            return;
        // Inject the content inside the iframe
        doc.open();
        doc.write(processedContent);
        doc.close();
        var injectConfluenceStyles = function () {
            var cssUrl = "https://d2j4j990zvhh26.cloudfront.net/microadtech.atlassian.net/wiki/s/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855-CDN/149126767/h/e5ec113c7bb51197b90a0bdd7a69e32bbdd0cb78bdb7bd577b561cbd6e6fe49b/_/download/contextbatch/css/_super/batch.css?assetVersion=1000.0.0-77ab427dd1e119827&externals=__local-default__&relative-url=true";
            var existingLink = doc.querySelector("link[href=\"" + cssUrl + "\"]");
            if (!existingLink) {
                var link = doc.createElement("link");
                link.rel = "stylesheet";
                link.href = cssUrl;
                doc.head.appendChild(link);
            }
        };
        var injectCustomStyles = function () {
            var styleContent = "\n            #content {\n              width: 100%;\n            }\n            .childpages-macro {\n              margin-top: 15px !important;\n            }\n            .toc-container {\n              padding-left: 25px;\n              margin-top: 20px;\n            }\n            .toc-container a, .childpages-macro li a {\n              margin-bottom: 10px;\n            }\n            .columnLayout {\n              display: flex;\n              width: 100%;\n              clear: both;\n              gap: 10px;\n            }\n            .columnLayout .cell {\n              vertical-align: top;\n            }\n            .columnLayout .cell.aside {\n              width: 29.9%;\n            }\n            .columnLayout .cell.sidebars {\n              width: 19.9%;\n            }\n            .cell {\n              display: table-cell;\n              padding: 0 10px;\n            }\n            .innerCell {\n              overflow-x: auto;\n            }\n            .cell,\n            .mceContentBody.cell,\n            .twoColumns .cell,\n            .threeColumns .cell,\n            .twoColumns .large,\n            .mceContentBody.header,\n            .mceContentBody.footer,\n            .threeColumns .large {\n              border: 0;\n              margin: 0;\n              padding: 0;\n              overflow: hidden;\n            }\n            .twoColumns .cell {\n              width: 49.9%;\n            }\n            .threeColumns .cell {\n              width: 33.3%;\n            }\n            .twoColumns .large {\n              width: 69.9%;\n            }\n            .threeColumns .large {\n              width: 59.9%;\n            }\n            div.aside + div.large,\n            div.large + div.aside,\n            div.large + div.sidebars,\n            .twoColumns div.cell + div.cell,\n            .threeColumns div.cell + div.cell + div.cell {\n              float: right;\n            }\n            .two-equal .normal {\n              width: 49.9%;\n            }\n            .two-left-sidebar .normal,\n            .two-right-sidebar .normal {\n              width: 69.9%;\n            }\n            .three-equal .cell {\n              width: 33.3%;\n            }\n          .three-with-sidebars .normal {\n            width: 59.9%;\n          }\n          .two-equal div.cell + div.cell {\n            float: right;\n          }\n          .three-equal div.cell + div.cell + div.cell,\n          .three-with-sidebars div.cell + div.cell + div.cell {\n            float: right;\n          }\n          .confluence-information-macro {\n            margin-top: 10px;\n            display: flex;\n            background-color: #E3FCEF;\n            padding: 10px;\n            gap: 5px;\n            margin-bottom: 5px;\n          }\n          .confluence-information-macro-note {\n            background-color: #FFFAE6;\n          }\n          .confluence-information-macro-information {\n            background-color: #DEEBFF;\n          }\n          .confluence-information-macro-tip {\n            background-color: #E3FCEF;\n          }\n          .aui-iconfont-approve, .confluence-information-macro-icon {\n            color: #22A06B;\n            margin-right: 5px;\n          }\n          .aui-iconfont-info {\n            color: #007bff;\n          }\n          .aui-iconfont-warning{\n            color: #E56910;\n          }\n      ";
            var styleTag = document.createElement("style");
            styleTag.innerHTML = styleContent;
            doc.head.appendChild(styleTag);
        };
        var injectTableOfContents = function () {
            var tocContainer = doc.querySelector(".client-side-toc-macro.conf-macro.output-block");
            if (!tocContainer)
                return;
            // Remove previous TOC to prevent duplication
            tocContainer.classList.add("toc-container");
            // Find all headings (h2, h3, h4)
            var headings = doc.querySelectorAll("h2, h3, h4");
            headings.forEach(function (heading, index) {
                var _a;
                var headingId = heading.id ? heading.id : "heading-" + index;
                var headingText = ((_a = heading.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || "Section " + (index + 1);
                // const headingText = heading.innerText;
                heading.id = headingId; // Assign an ID if it doesn't exist
                // Create a link for the TOC
                var link = document.createElement("a");
                link.href = "#" + headingId;
                link.innerText = headingText;
                link.style.display = "block";
                link.style.cursor = "pointer";
                link.style.marginLeft = (parseInt(heading.tagName[1]) - 2) * 10 + "px"; // Indent based on level
                // Add click event for smooth scrolling
                link.addEventListener("click", function (event) {
                    event.preventDefault();
                    var targetHeading = doc.getElementById(headingId);
                    if (targetHeading) {
                        targetHeading.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                });
                tocContainer.appendChild(link);
            });
        };
        // Call the function to inject CSS
        injectConfluenceStyles();
        injectCustomStyles();
        setTimeout(injectTableOfContents, 100);
        // Attach click event listener inside the iframe
        var attachClickListener = function () {
            var links = doc.querySelectorAll("a[data-linked-resource-id]");
            var handleClick = function (event) {
                event.preventDefault();
                // check if target is a link
                var target = event.target;
                // if target is not a link, find the closest link
                if (target.tagName !== "A") {
                    target = target.closest("a");
                    if (!target)
                        return;
                }
                var hasDataLinkedResourceId = target.getAttribute("data-linked-resource-id");
                var href = target.href;
                if (href && href === "#")
                    return;
                // check dont have data-linked-resource-id
                if (!hasDataLinkedResourceId) {
                    var pageId = href.split("/").pop();
                    // split pageId by # and get the first part
                    var pageIdParts = pageId === null || pageId === void 0 ? void 0 : pageId.split("#");
                    var pageIdWithoutHash = pageIdParts ? pageIdParts[0] : null;
                    if (pageIdWithoutHash)
                        onPageClick(pageIdWithoutHash);
                    return;
                }
                else {
                    var pageId = target.getAttribute("data-linked-resource-id");
                    if (pageId)
                        onPageClick(pageId);
                }
            };
            links.forEach(function (link) { return link.addEventListener("click", handleClick); });
            // Find links with href is '#'
            var linksWithHref = doc.querySelectorAll("a[href='#']");
            linksWithHref.forEach(function (link) { return link.addEventListener("click", handleClick); });
            // Find absolute links with https://enhanceinc.atlassian.net/wiki/spaces/EnhancePub/pages
            var absoluteLinks = doc.querySelectorAll("a[href^='https://enhanceinc.atlassian.net/wiki/spaces/EnhancePub/pages']");
            absoluteLinks.forEach(function (link) { return link.addEventListener("click", handleClick); });
            return function () {
                links.forEach(function (link) { return link.removeEventListener("click", handleClick); });
                linksWithHref.forEach(function (link) { return link.removeEventListener("click", handleClick); });
                absoluteLinks.forEach(function (link) { return link.removeEventListener("click", handleClick); });
            };
        };
        setTimeout(attachClickListener, 100); // Delay to allow rendering
        // **Download and Replace Images**
        var processImages = function () { return __awaiter(void 0, void 0, void 0, function () {
            var images;
            return __generator(this, function (_a) {
                images = doc.querySelectorAll("img");
                Array.from(images).forEach(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                    var originalSrc, token, response, blob, reader_1, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                originalSrc = img.src;
                                if (!originalSrc.includes("confluence/download/")) return [3 /*break*/, 6];
                                originalSrc = originalSrc.replace("operator/confluence/download/thumbnails", "operator/confluence/download/attachments");
                                img.srcset = "";
                                img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII=";
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 5, , 6]);
                                return [4 /*yield*/, getItem(TOKEN_KEY)];
                            case 2:
                                token = _a.sent();
                                return [4 /*yield*/, fetch(originalSrc, {
                                        headers: { Authorization: "AdTran " + token },
                                    })];
                            case 3:
                                response = _a.sent();
                                if (!response.ok)
                                    throw new Error("Failed to load " + originalSrc);
                                return [4 /*yield*/, response.blob()];
                            case 4:
                                blob = _a.sent();
                                reader_1 = new FileReader();
                                reader_1.onloadend = function () {
                                    img.src = reader_1.result; // Replace image src with Base64
                                };
                                reader_1.readAsDataURL(blob); // Convert blob to Base64
                                return [3 /*break*/, 6];
                            case 5:
                                error_1 = _a.sent();
                                console.error("Error loading image:", error_1);
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        processImages();
        return function () {
            // Cleanup event listeners
            doc.querySelectorAll("a[data-linked-resource-id]").forEach(function (link) {
                return link.removeEventListener("click", function () { });
            });
        };
    }, [processedContent, onPageClick]);
    return (React.createElement("div", { className: classes.contentInner },
        React.createElement("iframe", { ref: iframeRef, style: { width: "100%", height: "100%", border: "0px solid #ccc", paddingBottom: "20px" }, sandbox: "allow-scripts allow-same-origin" })));
};
export default WikiContent;
